export default __webpack_public_path__ + "static/media/startup.0beb90bb.jpg";